import { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";

function BootstrapDropdown({
  goals,
  importantVar = "index",
  setImportantVar = function () {
    return;
  },
  name,
  classStyle = "py-3",
}) {
  const [chosen, setChosen] = useState(
    name ? name(goals[0]) : goals[0][importantVar]
  );
  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="success"
        id="dropdown-basic"
        className={classStyle}
      >
        {chosen}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Array.isArray(goals) &&
          goals.map((goal, i) => {
            const goalObject =
              typeof goal === "object" ? goal : { [importantVar]: goal };
            goalObject.index = i;
            return (
              <Dropdown.Item
                onClick={() => {
                  if (name) setChosen(name(goal));
                  else setChosen(goal[importantVar]);
                  setImportantVar(goal[importantVar]);
                }}
              >
                {name ? name(goal) : goal[importantVar]}
              </Dropdown.Item>
            );
          })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default BootstrapDropdown;
